import { css } from '@emotion/react';
import styled from '@emotion/styled';

import CalendarIcon from '@/assets/icons/ic-calendar-plus.svg';

import { BREAKPOINTS, theme as customTheme } from '@/styles/themes/default';

import { slideToLeft, delayedAnimation, Card } from './shared';

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  min-height: 350px;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    min-height: 400px;
  }
`;

const BaseImage = styled.img`
  position: absolute;
  z-index: 1;
  left: 100%;
  height: auto;
  max-width: 290px;
  top: 0;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    margin-left: 20px;
    max-width: 316px;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    max-width: 420px;
  }
`;

const SpeakerImage1 = styled.img`
  position: absolute;
  z-index: 2;
  left: 100%;
  top: 120px;
  max-width: 77px;
  margin-left: 140px;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    margin-left: 195px;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    max-width: 102px;
    margin-left: 270px;
    top: 190px;
  }
`;

const SpeakerImage2 = styled.img`
  position: absolute;
  z-index: 2;
  left: 100%;
  top: 120px;
  max-width: 77px;
  margin-left: 230px;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    margin-left: 285px;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    max-width: 102px;
    margin-left: 390px;
    top: 190px;
  }
`;

const card1Styles = css`
  display: flex;
  align-content: center;
  z-index: 2;
  left: 100%;
  top: 120px;

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    top: 190px;
    padding: 16px 80px 16px 26px;
  }
`;

const card2Styles = css`
  z-index: 2;
  left: 100%;
  top: 180px;
  max-width: 165px;
  text-align: left;
  padding-right: 20px;

  p {
    font-size: 12px;
    line-height: 16px;
    margin: 6px 0 0 0;
  }

  h4 {
    font-size: 14px;
    line-height: 18px;
    color: ${customTheme.colors.brand.primary};
    margin: 0;
  }

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    top: 180px;
    max-width: 184px;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    top: 255px;
    padding: 16px 20px 16px 32px;
    max-width: 260px;

    p {
      font-size: 14px;
      line-height: 20px;
    }
  }
`;

export const Reception = () => {
  return (
    <Wrapper>
      <BaseImage css={slideToLeft} src="/images/landing/eventExample/reception-base.jpg" alt="posters example" />
      <Card css={[slideToLeft, card1Styles, delayedAnimation(0.7)]}>
        <CalendarIcon />
        <span>Oct - Nov</span>
      </Card>
      <Card css={[slideToLeft, card2Styles, delayedAnimation(1.1)]}>
        <h4>ABOUT</h4>
        <p>World’s most advanced scientific conference.</p>
      </Card>
      <SpeakerImage1
        css={[slideToLeft, delayedAnimation(1.5)]}
        src="/images/landing/eventExample/reception-speaker-1.png"
        alt="reception speaker example"
      />
      <SpeakerImage2
        css={[slideToLeft, delayedAnimation(1.9)]}
        src="/images/landing/eventExample/reception-speaker-2.png"
        alt="reception speaker example"
      />
    </Wrapper>
  );
};
